import { Image } from '@grupoboticario/flora-react'

import { useTracking } from '../TrackingContext'

export const Logo = () => {
  const data = useTracking()

  if (!data) return <div />

  if (!data.orderTraceabilityModel.salesLogoUrl) return <div />

  return (
    <Image
      src={data.orderTraceabilityModel.salesLogoUrl}
      alt={data.orderTraceabilityModel.cadExpedidor.nmExpedidor}
      css={{ margin: '20px 0 0 0', objectFit: 'contain', width: '140px' }}
    />
  )
}
